import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=9f12834c&scoped=true&"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./AddressAutocomplete.vue?vue&type=style&index=0&id=9f12834c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f12834c",
  null
  
)

export default component.exports